<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'home',
  mounted() {
    // message.info('首页')
  },
  methods: {
    onChange() {
      
    }
  }
}
</script>
